import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["content", 'header'];

  connect() {

    $(document).ready(function () {
      $(".head-accordion").each(function () {
        makeAccordion(this)
      })
    });
  }

  toggle() {
    if ($(this.headerTarget).hasClass('is-active')) {
      close(this.headerTarget, this.contentTarget);
    } else {
      closeOthers(this.headerTarget);
      open(this.headerTarget, this.contentTarget);
    }
  }
}

function open(head, content) {
  $(head).addClass("is-active")
  $(head).find('> i').removeClass("fa-angle-down").addClass("fa-angle-up");
  $(content).slideDown(200)
}

function close(head, content) {
  $(head).removeClass("is-active")
  $(head).find('> i').removeClass("fa-angle-up").addClass("fa-angle-down");
  $(content).slideUp(200)
}

function closeOthers(head) {
  let elements = $(head).parents('.accordion-content').map(function () {
    return "#" + this.id
  }).get()
  let headElements = []
  if (elements.length) {
    headElements = $($(head).parents('.accordion-content')[0]).siblings('.head-accordion').map(function () {
      return "#" + this.id
    }).get()
  }
  $('.accordion-content').not(elements.join(",")).each(function () {
    $(this).slideUp(200)
  })
  $('.head-accordion').not(headElements.join(",")).each(function () {
    $(this).removeClass("is-active")
    $(this).find('> i').removeClass("fa-angle-up").addClass("fa-angle-down");
  })
}

function makeAccordion(ele) {
  let element = $(ele).parent();
  let content = element.find('.accordion-content')[0]
  if ($(content).find('.item a.is-active').length) {
    element.find('.head-accordion').addClass("is-active");
    $(content).slideDown(200);
    element.find(".head-accordion > i").removeClass("fa-angle-down").addClass("fa-angle-up");
  } else {
    element.find('.head-accordion').removeClass("is-active");
    $(content).slideUp(200);
    element.find(".head-accordion > i").removeClass("fa-angle-up").addClass("fa-angle-down");
  }
}